/**
 * Converts rows of data to a CSV string and triggers a browser download.
 *
 * @param {string[]} headers - Column headers
 * @param {string[][]} rows - Array of row arrays (each row is an array of cell values)
 * @param {string} filename - The downloaded file name (e.g. "staff-export.csv")
 */
export const downloadCSV = (headers, rows, filename) => {
  const csv = [headers, ...rows]
    .map((row) =>
      row.map((val) => `"${String(val).replace(/"/g, '""')}"`).join(",")
    )
    .join("\n");
  const blob = new Blob([csv], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  const timestamp = new Date()
    .toISOString()
    .slice(0, 16)
    .replace("T", "_")
    .replace(":", "-");
  link.download = filename.replace(".csv", `-${timestamp}.csv`);
  link.click();
  // Delay revoking so the browser has time to start the download
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
